<template>
  <div>
    <div class='title_img'>
      <img @dragstart.prevent :src="params.picurl" alt="" class='img_log_model'>
      <!-- <div class='title_name' v-if='tabfrom.typename'>{{tabfrom.typename}}</div> -->
    </div>
    <div class='is_title'>
    <div style="margin: 1rem 5%;width: 70%;" v-if='seach'><seachlange :seach='seach'></seachlange></div>
    <div :style="{width: seach?'90%':'',marginLeft: seach?'5%':''}">
      <!-- <div v-for='(v,i) in tabfrom.list' @click='handlist(i)'>{{v}}</div> -->
        <div class="listbox" style='position: relative;' v-if='tabfrom.list.length>1'>
            <!-- <div style='padding: 8px 20px;display: inline-block;
        border-top: 1px solid #CCC;
        border-right: 1px solid #CCC;'>{{tabfrom.typename}}</div> -->
            <ul class="list" ref="scrollRef">
              <li v-if='tabfrom.typename'
               style="position: absolute;top: 0;left: 0;background:#fff;border: 1px solid #fff;
              color: #09666E;">{{tabfrom.typename}}</li>
              <li v-if='tabfrom.typename' style="color: #fff;border: 1px solid #fff;">{{tabfrom.typename}}</li>
              <li v-for='(v,i) in tabfrom.list' :style='{borderLeft:"1px solid #CCC",
              borderRight:i==(tabfrom.list.length-1)?"1px solid #CCC":""}'
              style="border-bottom: 1px solid #ccc;border-top: 1px solid #ccc;"
                  @click='handlist(i)' :class='tabfrom.taname==v?"isright":""'>{{v}}</li>　　
            </ul>
          </div>
    </div>
</div>

  </div>
</template>
<script>
  import seachlange from '../login/seachlange.vue'

  export default {
    props: ['params', 'tabfrom','seach'],
    components:{seachlange},
    data() {
      return {
        onlinestate:sessionStorage['onlinestate'],
        islang : window.localStorage.guanwanglang,
        arrlist:[]
      }
    },
    mounted() {
      if (this.tabfrom.taname == this.$lang.grsm) {
        let height = this.$refs.scrollRef.scrollWidth;
        this.$refs.scrollRef.scrollTo(height,0);
      }
    },
    methods: {
      postdata(){
        this.$ajax({
          method:'post',
          url:this.$api.yuyuekaihu
        }).then(res=>{
          if(res.data.qmiscode === 1000){
          }else{
            this.$message.warning(res.data.qmismsg)
          }
        })
      },
      handlist(i) {
        if (i == 2) {
          this.postdata()
        }
        if(this.tabfrom.urllist[i]) {
          if(this.tabfrom.urllist[i].split('http').length>1){
            if(this.tabfrom.urllist[i].split('?lang=').length>1){
              window.open(this.tabfrom.urllist[i] + this.islang)
            }else{
              window.open(this.tabfrom.urllist[i])
            }
            // if(this.onlinestate =='ipad'){
            //   window.open('https://hk.iqmis.com/app/apk/appdownload/khappcn.html')
            // }else{
            //   window.open(this.tabfrom.urllist[i] + this.islang)
            // }
          }else{
            this.$router.push(this.tabfrom.urllist[i])
            // console.log(this.$router)
            // let str = location.protocol+location.host+"/qmisgroup"+this.tabfrom.urllist[i]
            // location.href = str
          }
        }
      },
    }
  }
</script>

<style scoped>

.pc_minHeight .title_img{
  min-height: 470px;
}
.ipad_minHeight .title_img{
  min-height: 324px;
}
.phone_minHeight .title_img{
  min-height: 158px;
}
  .isright{
   background-color: #0c8b97 !important;
   color: #fff !important;
  }

  .listbox {}

  .listbox .list li {
    padding: 8px 20px;
    /* margin: 8px 0; */
    border-top: 1px solid #CCC;
    /* border-right: 1px solid #CCC; */
  }

  .list {
    margin-bottom: 0;
    padding: 0;
    /* border-bottom: 1px solid #eee; */
  }

/* .listbox */
   .list {
    list-style-type: none;
    display: -webkit-box;
    -webkit-overflow-scrolling:touch;
    /* overflow: auto; */
    overflow-x: scroll;
      /*隐藏滚动条，当IE下溢出，仍然可以滚动*/
    -ms-overflow-style:none;
    /*火狐下隐藏滚动条*/
    scrollbar-width: none;
    /* overflow-x: hidden;
    	overflow-y: scroll; */
  }
  .listbox .list::-webkit-scrollbar{
      display:none;
  }
</style>



// WEBPACK FOOTER //
// src/components/titleimg/title_img.vue